module.exports = __webpack_public_path__ + "img/bag-tag-findmykit-banner.fd117029.png";